// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { POLARIS_PROVIDER_ROLES } from '../../constants/appointmentTypes';

export const ACCOUNT_TYPE_OPTIONS = Object.entries(POLARIS_PROVIDER_ROLES).map(([value, def]) => ({
  value,
  label: def.display,
}));

const COMMON_TIMEZONE_OPTIONS = [
  { value: 'America/New_York', label: 'United States, New York City (EST)' },
  { value: 'America/Chicago', label: 'United States, Chicago (CST)' },
  { value: 'America/Denver', label: 'United States, Denver (MST)' },
  { value: 'America/Los_Angeles', label: 'United States, Los Angeles (PST)' },
  { value: 'America/Anchorage', label: 'United States, Anchorage (AKST)' },
  { value: 'Pacific/Honolulu', label: 'United States, Honolulu (HST)' },
];

const supportedTimezones = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : [];
const commonTimezoneLabels = new Map(COMMON_TIMEZONE_OPTIONS.map((option) => [option.value, option.label]));

export const TIMEZONE_OPTIONS = [
  ...new Set([...COMMON_TIMEZONE_OPTIONS.map((option) => option.value), ...supportedTimezones]),
].map((value) => ({ value, label: commonTimezoneLabels.get(value) ?? value }));

export const ITEMS_PER_PAGE = 5;

export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
  { value: 'DC', label: 'District of Columbia' },
];

export const LICENSE_STATUS_OPTIONS = [
  { value: 'Awaiting Review', label: 'Awaiting Review' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Active', label: 'Active' },
  { value: 'Invalid', label: 'Invalid' },
  { value: 'Expired', label: 'Expired' },
];

export const LICENSE_STATUS_INITIAL = 'Awaiting Review';
export const LICENSE_STATUS_ERROR_STATES = ['Invalid', 'Expired'] as const;
